import { render, staticRenderFns } from "./Context.vue?vue&type=template&id=15d0c539&scoped=true"
import script from "./Context.vue?vue&type=script&lang=js"
export * from "./Context.vue?vue&type=script&lang=js"
import style0 from "./Context.vue?vue&type=style&index=0&id=15d0c539&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d0c539",
  null
  
)

export default component.exports